import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import setUpAxios from '../../helperFunctions/helperFunctions';

interface BadgeProps {
  url: string;
}

export default class Badge extends React.Component<BadgeProps, any> {
  state = {
    count: 0,
  }

  componentDidMount() {
    setUpAxios();
    this.fetchData();
  }

  componentDidUpdate() {
    if (this.state.count > 0) {
      $(ReactDOM.findDOMNode(this))
        .closest('.link-group')
        .children('.name')
        .addClass('badged');
    }
  }

  render() {
    if (this.state.count === 0) {
      return null;
    }
    return (
      <div className="notification">
        {this.state.count}
      </div>
    );
  }

  fetchData = () => {
    axios.get(this.props.url).then((response) => {
      this.setState({
        count: response.data,
      });
    });
  }
}
